module.exports = __webpack_public_path__ + "img/baquan.4f1d716a.jpg";